import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { DialogContent, DialogTitle, DialogActions, Button, withStyles } from "@material-ui/core";
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-material-ui";
import { useIntl, defineMessages } from "react-intl";
import useSWR from "swr";
import Moment from "moment";
import { useHistory } from "react-router";
import cn from "classnames";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import MailIcon from "@material-ui/icons/Mail";
import SpeakerNotesIcon from "@material-ui/icons/SpeakerNotes";
import DateRangeIcon from "@material-ui/icons/DateRange";
import ScheduleIcon from "@material-ui/icons/Schedule";
import NotificationsIcon from "@material-ui/icons/Notifications";

import { FormikAsyncSelect } from "../../../../components/AsyncSelect";
import { AjaxBlackout, createDialogConfirm, Flex, createSnackbar, Tipografia } from "../../../../_common";
import { NU_TIPO_ATIVIDADE_ID } from "../../../../_common/constantes";
import { WhatsAppIcon } from "../../../whatsapp/Header/styles";
import { eTemplateStatus } from "../../../whatsapp/RegistrationRequest/constants";

const INITIAL_VALUES = {
  tipoAtividadeId: 0,
  templateEmailId: null,
  observacoes: "",
  dia: "",
  horas: "",
  notificarId: null,
  nuTipoAtividade: 0,
};

export const TEMPO_NOTIFICACAO_LABELS = defineMessages({
  naoNotificar: { defaultMessage: "Não notificar" },
  naHoraAgendada: { defaultMessage: "Na hora agendada" },
  notificar5MinutosAntes: { defaultMessage: "5 minutos antes" },
  notificar15MinutosAntes: { defaultMessage: "15 minutos antes" },
  notificar30MinutosAntes: { defaultMessage: "30 minutos antes" },
  notificar1HoraAntes: { defaultMessage: "1 hora antes" },
});

const TEMPO_NOTIFICACAO = [
  { id: -1, descricao: TEMPO_NOTIFICACAO_LABELS.naoNotificar },
  { id: 0, descricao: TEMPO_NOTIFICACAO_LABELS.naHoraAgendada },
  { id: 5, descricao: TEMPO_NOTIFICACAO_LABELS.notificar5MinutosAntes },
  { id: 15, descricao: TEMPO_NOTIFICACAO_LABELS.notificar15MinutosAntes },
  { id: 30, descricao: TEMPO_NOTIFICACAO_LABELS.notificar30MinutosAntes },
  { id: 60, descricao: TEMPO_NOTIFICACAO_LABELS.notificar1HoraAntes },
];

function ModalCriarAtividade({ ids, filtros, callback = () => null, isListaLeadsSemAtividades, classes }) {
  const intl = useIntl();
  const history = useHistory();
  const [listaTipoAtividade, setListaTipoAtividade] = useState([]);

  const { data: tiposAtividade, isValidating: carregandoTiposAtividade } = useSWR("/api/pipeline/TipoAtividade/Listar");
  const { data: templatesEmail } = useSWR("/api/pipeline/TemplateEmail/BuscarSelecao");
  const { data: templatesWhatsapp } = useSWR({
    url: "/api/pipeline/whatsapp/listarTemplates",
    method: "post",
    data: { status: [eTemplateStatus.approved] },
  });

  useEffect(
    () => {
      if (!carregandoTiposAtividade)
        setListaTipoAtividade(
          tiposAtividade.filter(
            x =>
              x.nuTipoAtividade === NU_TIPO_ATIVIDADE_ID.ENVIAR_EMAIL ||
              x.nuTipoAtividade === NU_TIPO_ATIVIDADE_ID.RETORNO_LIGACAO ||
              x.nuTipoAtividade === NU_TIPO_ATIVIDADE_ID.VERIFICAR_DISPONIBILIDADE_REUNIAO ||
              x.nuTipoAtividade === NU_TIPO_ATIVIDADE_ID.CONTINUAR_FILTRO ||
              x.nuTipoAtividade === NU_TIPO_ATIVIDADE_ID.CONFIRMAR_REUNIAO ||
              x.nuTipoAtividade === NU_TIPO_ATIVIDADE_ID.ENVIAR_WHATSAPP
          )
        );
    },
    [carregandoTiposAtividade]
  );

  const navigateAtividades = values => {
    history.push({
      pathname: "/spotter/atividades",
      state: {
        filtros: {
          filtroEnviarEmail: NU_TIPO_ATIVIDADE_ID.ENVIAR_EMAIL === values.nuTipoAtividade,
          filtroRetornoLigacao: NU_TIPO_ATIVIDADE_ID.RETORNO_LIGACAO === values.nuTipoAtividade,
          filtroVerificarDisponibilidadeReuniao:
            NU_TIPO_ATIVIDADE_ID.VERIFICAR_DISPONIBILIDADE_REUNIAO === values.nuTipoAtividade,
          filtroContinuarFiltro: NU_TIPO_ATIVIDADE_ID.CONTINUAR_FILTRO === values.nuTipoAtividade,
          filtroConfirmarReuniao: NU_TIPO_ATIVIDADE_ID.CONFIRMAR_REUNIAO === values.nuTipoAtividade,
          filtroEnviarWhatsApp: NU_TIPO_ATIVIDADE_ID.ENVIAR_WHATSAPP === values.nuTipoAtividade,
        },
        resetAba: !!isListaLeadsSemAtividades,
      },
    });
  };

  const onSubmit = values => {
    AjaxBlackout.Show();
    axios
      .post("/api/pipeline/atividade/CriarEmMassa", {
        ...values,
        leadIds: ids,
        data: `${values.dia}T${values.horas}`,
        filtros,
      })
      .then(resp => {
        if (resp && ids.length === 1) {
          callback(resp);
          AjaxBlackout.Hide();
          createDialogConfirm({
            title: intl.formatMessage({ defaultMessage: "Atividade(s) criada(s)" }),
            text: intl.formatMessage({
              defaultMessage:
                "Sua(s) atividade(s) foram criadas com sucesso, você pode conferi-las na tela de atividades.",
            }),
            tamanhoMaximo: "sm",
            fullWidth: true,
            actions: unmount => (
              <DialogActions>
                <Button
                  onClick={() => {
                    unmount();
                    callback(true);
                  }}
                >
                  {intl.formatMessage({ defaultMessage: "Fechar" })}
                </Button>
                <Button
                  color="primary"
                  onClick={() => {
                    unmount();
                    navigateAtividades(values);
                  }}
                >
                  {intl.formatMessage({ defaultMessage: "Ir para a tela de atividades" })}
                </Button>
              </DialogActions>
            ),
          });
        } else if (values.redirecionar) {
          navigateAtividades(values);
        } else callback(resp);
      })
      .catch(error => {
        console.error(error);
        createSnackbar(intl.formatMessage({ defaultMessage: "Operação falhou" }));
      })
      .finally(() => AjaxBlackout.Hide());
  };

  const validate = values => {
    const errors = {};
    if (values.tipoAtividadeId === 0)
      errors.tipoAtividadeId = intl.formatMessage({ defaultMessage: "*Campo obrigatório" });
    if (values.dia === "") errors.dia = intl.formatMessage({ defaultMessage: "*Campo obrigatório" });
    if (values.horas === "") errors.horas = intl.formatMessage({ defaultMessage: "*Campo obrigatório" });
    if (values.notificarId === null) errors.notificarId = intl.formatMessage({ defaultMessage: "*Campo obrigatório" });

    return errors;
  };

  const onSubmitConfirm = values => {
    createDialogConfirm({
      title: intl.formatMessage({ defaultMessage: "Confirmar criação de atividades" }),
      text: intl.formatMessage(
        {
          defaultMessage:
            "Tem certeza que deseja criar {qtdAtividades} ações em massa do tipo {tipoAtividade} para {qtdAtividades} leads selecionados?",
        },
        {
          qtdAtividades: ids.length,
          tipoAtividade: tiposAtividade.filter(x => x.nuTipoAtividade === values.nuTipoAtividade)[0].descricao,
        }
      ),
      tamanhoMaximo: "sm",
      fullWidth: true,
      actions: unmount => (
        <DialogActions>
          <Button
            onClick={() => {
              unmount();
              callback(false);
            }}
          >
            {intl.formatMessage({ defaultMessage: "CANCELAR" })}
          </Button>
          <Button
            onClick={() => {
              values.redirecionar = false;
              unmount();
              callback(true);
              onSubmit(values);
            }}
          >
            {intl.formatMessage({ defaultMessage: "CONFIRMAR" })}
          </Button>
          <Button
            color="primary"
            onClick={() => {
              values.redirecionar = true;
              unmount();
              onSubmit(values);
            }}
          >
            {intl.formatMessage({ defaultMessage: "CONFIRMAR E IR PARA ATIVIDADES" })}
          </Button>
        </DialogActions>
      ),
    });
  };

  return (
    <Formik
      initialValues={INITIAL_VALUES}
      onSubmit={ids.length > 1 ? onSubmitConfirm : onSubmit}
      onReset={() => callback(false)}
      validate={validate}
    >
      {bag => {
        const handleChangeTipoAtividade = event => {
          const selectedId = event.target.value;
          const selectedItem = listaTipoAtividade.find(item => item.id === selectedId);
          if (selectedItem) {
            bag.setFieldValue("tipoAtividadeId", selectedItem.id);
            bag.setFieldValue("nuTipoAtividade", selectedItem.nuTipoAtividade);
          }
        };

        return (
          <Form>
            <DialogTitle>{intl.formatMessage({ defaultMessage: "Criar atividade em massa" })}</DialogTitle>
            <DialogContent>
              <Flex flexDirection="column">
                {isListaLeadsSemAtividades && (
                  <Flex className={classes.subtitulo}>
                    <Tipografia tipo="notaLegendas" cor="darkSecondaryText">
                      {intl.formatMessage(
                        {
                          defaultMessage:
                            "Você está criando uma atividade em massa para {quantidadeLeads} {labelQuantidade}",
                        },
                        { quantidadeLeads: ids.length, labelQuantidade: ids.length === 1 ? "lead" : "leads" }
                      )}
                    </Tipografia>
                  </Flex>
                )}
                <Flex id="container-tipo-atividade" flexDirection="row">
                  <Flex id="tipo-atividade" alignItems="baseline" className={classes.container}>
                    <Flex className={classes.icon}>
                      <AssignmentTurnedInIcon />
                    </Flex>
                    <Flex className={classes.container}>
                      <FormikAsyncSelect
                        id="tipoAtividadeId"
                        name="tipoAtividadeId"
                        label={intl.formatMessage({
                          defaultMessage: "Tipo de atividade",
                        })}
                        options={listaTipoAtividade}
                        value={bag.values.tipoAtividadeId}
                        onChange={handleChangeTipoAtividade}
                        enableSearch
                        fullWidth
                        carregarSomenteAoAbrir
                        required
                      />
                    </Flex>
                  </Flex>
                </Flex>
                {bag.values.tipoAtividadeId ===
                  tiposAtividade.find(x => x.nuTipoAtividade === NU_TIPO_ATIVIDADE_ID.ENVIAR_EMAIL).id && (
                  <Flex id="container-template-email" flexDirection="row">
                    <Flex id="template-email" alignItems="baseline" className={classes.container}>
                      <Flex className={classes.icon}>
                        <MailIcon />
                      </Flex>
                      <Flex className={classes.container}>
                        <FormikAsyncSelect
                          id="templateEmailId"
                          name="templateEmailId"
                          label={intl.formatMessage({
                            defaultMessage: "Template de e-mail",
                          })}
                          options={templatesEmail}
                          getLabel={item => item.nome}
                          getInputLabel={item => item.nome}
                          enableSearch
                          fullWidth
                          carregarSomenteAoAbrir
                        />
                      </Flex>
                    </Flex>
                  </Flex>
                )}
                {bag.values.tipoAtividadeId ===
                  tiposAtividade.find(x => x.nuTipoAtividade === NU_TIPO_ATIVIDADE_ID.ENVIAR_WHATSAPP).id && (
                  <Flex id="container-template-whatsapp" flexDirection="row">
                    <Flex id="template-whatsapp" alignItems="baseline" className={classes.container}>
                      <Flex className={classes.icon}>
                        <WhatsAppIcon color="rgb(102, 102, 102)" size={32} />
                      </Flex>
                      <Flex className={classes.container}>
                        <FormikAsyncSelect
                          id="templateMensagemHSMId"
                          name="templateMensagemHSMId"
                          label={intl.formatMessage({
                            defaultMessage: "Template de Whatsapp",
                          })}
                          options={templatesWhatsapp}
                          getLabel={item => item.nome}
                          getInputLabel={item => item.nome}
                          enableSearch
                          fullWidth
                          carregarSomenteAoAbrir
                        />
                      </Flex>
                    </Flex>
                  </Flex>
                )}
                <Flex id="container-data-hora" flexDirection="row" justifyContent="space-between">
                  <Flex id="data" alignItems="baseline" className={classes.container}>
                    <Flex className={classes.icon}>
                      <DateRangeIcon />
                    </Flex>
                    <Flex className={cn(classes.container, classes.espaco)}>
                      <Field
                        component={TextField}
                        name="dia"
                        id="dia"
                        fullWidth
                        inputProps={{ type: "date", min: new Moment().format("YYYY-MM-DD") }}
                        InputLabelProps={{ shrink: true }}
                        label={intl.formatMessage({ defaultMessage: "Dia" })}
                        required
                      />
                    </Flex>
                  </Flex>
                  <Flex id="hora" alignItems="baseline" className={classes.container}>
                    <Flex className={classes.icon}>
                      <ScheduleIcon />
                    </Flex>
                    <Flex className={classes.container}>
                      <Field
                        component={TextField}
                        name="horas"
                        id="horas"
                        fullWidth
                        inputProps={{ type: "time" }}
                        InputLabelProps={{ shrink: true }}
                        label={intl.formatMessage({ defaultMessage: "Horas" })}
                        required
                      />
                    </Flex>
                  </Flex>
                </Flex>
                <Flex id="container-notificar" flexDirection="row">
                  <Flex id="notificar" alignItems="baseline" className={classes.container}>
                    <Flex className={classes.icon}>
                      <NotificationsIcon />
                    </Flex>
                    <Flex className={classes.container}>
                      <FormikAsyncSelect
                        id="notificarId"
                        name="notificarId"
                        label={intl.formatMessage({
                          defaultMessage: "Notificar",
                        })}
                        getLabel={item => intl.formatMessage(item.descricao)}
                        getInputLabel={item => intl.formatMessage(item.descricao)}
                        options={TEMPO_NOTIFICACAO}
                        enableSearch
                        fullWidth
                        required
                      />
                    </Flex>
                  </Flex>
                </Flex>
                <Flex id="container-observacoes" flexDirection="row">
                  <Flex id="observacoes" alignItems="baseline" className={classes.container}>
                    <Flex className={classes.icon}>
                      <SpeakerNotesIcon />
                    </Flex>
                    <Flex className={classes.container}>
                      <Field
                        name="observacoes"
                        component={TextField}
                        label={intl.formatMessage({
                          defaultMessage: "Observações",
                        })}
                        placeholder={intl.formatMessage({
                          defaultMessage: "Faça suas observações",
                        })}
                        multiline
                        fullWidth
                        value={bag.values.observacoes}
                        rows={4}
                        rowsMax={4}
                        inputProps={{ maxLength: 2000 }}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
            </DialogContent>
            <DialogActions>
              <Button onClick={bag.handleReset}>{intl.formatMessage({ defaultMessage: "Cancelar" })}</Button>
              <Button onClick={bag.handleSubmit} color="primary">
                {intl.formatMessage({ defaultMessage: "Salvar" })}
              </Button>
            </DialogActions>
          </Form>
        );
      }}
    </Formik>
  );
}

ModalCriarAtividade.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  filtros: PropTypes.object,
  callback: PropTypes.func,
  isListaLeadsSemAtividades: PropTypes.bool,
};

export default withStyles({
  container: {
    width: "100%",
  },
  espaco: {
    marginRight: 16,
  },
  icon: {
    marginRight: 8,
    color: "rgb(102, 102, 102)",
  },
  subtitulo: { marginBottom: 8 },
})(ModalCriarAtividade);
